import { MockFactory } from '@tino-frontend/mocks'
import { BillListResponseV3, BillStatus } from '@types'
import { allLineItemsMock } from '@fixtures/apis/bill/line-item/all-line-items'
import { billBaseMock } from '@fixtures/apis/bill/detail-v3/bill-base'
import { lineItemInstallment } from '@fixtures/apis/bill/line-item/installment'

// Bill
const bill0 = billBaseMock.build(
  {
    ...billBaseMock.source,
    id: 'fatura-0',
    status: BillStatus.Paid,
    line_item_groups: allLineItemsMock.source,
    flags: {
      ...billBaseMock.source.flags,
      has_debit: true,
      is_empty: false,
      is_zero: false,
      show_amounts_header: true,
    },
  },
  { mergeArray: false }
)
const bill1 = billBaseMock.build(
  {
    ...billBaseMock.source,
    id: 'fatura-1',
    status: BillStatus.Overdue,
    line_item_groups: [
      {
        line_items: [lineItemInstallment.source],
        is_paid: false,
      },
    ],
    flags: {
      ...billBaseMock.source.flags,
      has_debit: false,
      is_empty: false,
      is_zero: false,
      show_amounts_header: true,
    },
    payable: true,
  },
  { mergeArray: false }
)
const bill2 = billBaseMock.build(
  {
    ...billBaseMock.source,
    id: 'fatura-2',
    status: BillStatus.Overdue,
    line_item_groups: [
      {
        line_items: [lineItemInstallment.source],
        is_paid: false,
      },
    ],
    flags: {
      ...billBaseMock.source.flags,
      has_debit: false,
      is_empty: false,
      is_zero: false,
      show_amounts_header: true,
    },
  },
  { mergeArray: false }
)
const bill3 = billBaseMock.build(
  {
    ...billBaseMock.source,
    id: 'fatura-3',
    status: BillStatus.Overdue,
    flags: {
      ...billBaseMock.source.flags,
      has_debit: false,
      is_empty: true,
      is_zero: false,
      show_amounts_header: true,
    },
  },
  { mergeArray: false }
)
const bill4 = billBaseMock.build(
  {
    ...billBaseMock.source,
    id: 'fatura-4',
    status: BillStatus.Closed,
    flags: {
      ...billBaseMock.source.flags,
      has_debit: false,
      is_empty: true,
      is_zero: false,
      show_amounts_header: true,
    },
  },
  { mergeArray: false }
)
const bill5 = billBaseMock.build(
  {
    ...billBaseMock.source,
    id: 'fatura-5',
    status: BillStatus.Closed,
    flags: {
      ...billBaseMock.source.flags,
      is_empty: true,
      is_zero: true,
      show_amounts_header: true,
    },
  },
  { mergeArray: false }
)
const bill6 = billBaseMock.build(
  {
    ...billBaseMock.source,
    id: 'fatura-6',
    status: BillStatus.Open,
    flags: {
      ...billBaseMock.source.flags,
      is_empty: true,
      is_zero: true,
      show_amounts_header: true,
    },
  },
  { mergeArray: false }
)
const bill7 = billBaseMock.build(
  {
    ...billBaseMock.source,
    id: 'fatura-7',
    status: BillStatus.Open,
    flags: {
      ...billBaseMock.source.flags,
      is_empty: true,
      is_zero: true,
      show_amounts_header: true,
    },
  },
  { mergeArray: false }
)
const bill8 = billBaseMock.build(
  {
    ...billBaseMock.source,
    id: 'fatura-8',
    status: BillStatus.Open,
    line_item_groups: [
      {
        line_items: [lineItemInstallment.source],
        is_paid: false,
      },
    ],
    flags: {
      ...billBaseMock.source.flags,
      show_amounts_header: true,
    },
  },
  { mergeArray: false }
)
const bill9 = billBaseMock.build(
  {
    ...billBaseMock.source,
    id: 'fatura-9',
    status: BillStatus.Open,
    line_item_groups: [
      {
        line_items: [lineItemInstallment.source],
        is_paid: false,
      },
    ],
    flags: {
      ...billBaseMock.source.flags,
      show_amounts_header: true,
    },
  },
  { mergeArray: false }
)

export const billListOverdueMock = new MockFactory<BillListResponseV3>({
  current_bill_id: 'fatura-2',
  bills: [bill0, bill1, bill2, bill3, bill4, bill5, bill6, bill7, bill8, bill9],
})
